import { Injectable, NgZone } from '@angular/core';
import { GlobalPubSubService as GlobalPubSubParentService } from '@cnaf/cnaf-commons-mon-compte-appli';
import { ContacterCafCourrielComponent } from '../03-contactermacaf-parcourriel/contactercafcourriel.component';
import { LIBELLE_EVENT_CAMILLE } from '../constants/configlibelles';

/**
 * Service that allows Angular components to receive and fire
 * events from outside
 *
 * Usage from outside of Angular:
 *   window.fireAngularEvent('sampleEventName', args)
 *   window.subscribeToAngularEvent('sampleEventName', fn)
 *
 * Usage from Angular component:
 *   globalPubSub.fireEvent('sampleEventName', args)
 *   globalPubSub.subscribe('sampleEventName', fn)
 */

@Injectable()
export class GlobalPubSubService extends GlobalPubSubParentService {

    allowedEvents: Map<string, { subscribe: boolean }> = new Map([
        [LIBELLE_EVENT_CAMILLE.envoi, { subscribe: true }],
        [LIBELLE_EVENT_CAMILLE.envoiOk, { subscribe: true }],
        [LIBELLE_EVENT_CAMILLE.envoiKo, { subscribe: true }],
        [LIBELLE_EVENT_CAMILLE.reset, { subscribe: true }]
    ]);

    contacterCafCourrielComponent!: ContacterCafCourrielComponent;

    constructor(protected readonly zone: NgZone) {
        super(zone);
        super.init();
    }

    /**
     * Exécute une fonction de ce module lors de la réception d'un évènement
     * @param eventName nom de l'évènement émis
     * @param args arguments pour la fonction à appeler
     */
    fireEventAngularHandler(eventName: string, args: any): void {
        this.subscriptions[eventName].forEach(fn => {
            // Seules les références des fonctions existantes peuvent être appelées

            if (fn === this.contacterCafCourrielComponent?.libelleEventCamilleEnvoi ||
                fn === this.contacterCafCourrielComponent?.libelleEventCamilleEnvoiOk ||
                fn === this.contacterCafCourrielComponent?.libelleEventCamilleEnvoiKo ||
                fn === this.contacterCafCourrielComponent?.libelleEventCamilleReset) {
                fn.apply(this.contacterCafCourrielComponent, args);
            }
        });
    }
}
